<template>
    <v-dialog v-model="localDialog" persistent max-width="600px">
        <v-card>
            <v-card-title class="gris--text">
                APLICAR PAGO DE {{ this.editedItem.contratante }}
            </v-card-title>
            <v-spacer></v-spacer>

            <v-card-subtitle class="text-grey">

                <v-alert type="warning" prominent class="mt-4" icon="mdi-information-outline">
                    Al ser aplicado el pago se generará la <strong>factura</strong>, es necesario validar la
                    información antes de aplicar.
                </v-alert>

                Se aplicará el pago <strong>{{ this.editedItem.recibo }}</strong> de <strong>{{ this.editedItem.recibos
                }}</strong>. Por la cantidad de <strong> {{ $formatCurrency(
                        this.editedItem.pago) }}</strong><br />
                Se facturará a
                <!-- <strong>PUBLICO EN GENERAL</strong>  -->
                <strong>{{ this.datosFiscales?.RFC }}</strong> y se envia a el correo <strong>{{
                    this.datosFiscales?.Correo }}</strong>.
            </v-card-subtitle>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-select return-object single-line v-model="FormaPago.CodPago" :items="tipopagos"
                        :item-text="'Nombre'" :item-value="'CodPago'" label="¿Como pago? " color="blue" outlined dense
                        :rules="[rules.ruleSelectDetallepago]"></v-select>
                    <v-text-field v-model="Referencia" maxlength="4" :rules="[rules.ruleRef4dig]" label="¿Tiene referencia?"
                        outlined dense></v-text-field>
                    <!-- <v-text-field v-model="editedItem.Membresia" label="Nombre"></v-text-field>
            <v-text-field v-model="editedItem.email" label="Email"></v-text-field> -->
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="green darken-1" text :disabled="!valid" @click="save">REGISTRAR</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        isOpen: Boolean, // Para controlar la visibilidad del modal
        item: Object // El ítem a editar
    },
    computed: {
        rules() {
            return this.$rules;
        }
    },
    data() {
        return {
            localDialog: false,
            valid: false,
            tipopagos: null,
            FormaPago: {
                Nombre: null,
                CodPago: ''
            },
            Referencia: null,
            dialog: this.value,
            editedItem: { ...this.item },
            datosFiscales: null
        };
    },
    watch: {
        isOpen(val) {
            this.localDialog = val;
            if (val) this.editedItem = { ...this.item };
        },
        item(val) {
            this.editedItem = { ...val };
            if (val) { // Cuando el modal se abre, obtenemos datos
                this.obtieneDatosFiscales();
            }
        }
    },
    mounted() {
        
        this.obtieneTipodePago()
    },
    methods: {
        close() {
            this.$emit("close", false);
            this.FormaPago = {
                Nombre: null,
                CodPago: ''
            },
                this.Referencia = null
            this.editedItem = {}
        },
        save() {
            this.editedItem = { ...this.editedItem, CodPago: this.FormaPago.CodPago.CodPago, Referencia: this.Referencia }
            this.$emit("save", this.editedItem);
            this.FormaPago = {
                Nombre: null,
                CodPago: ''
            },
                this.Referencia = null
            this.editedItem = {}
            this.close();
        },
        obtieneTipodePago() {
            this.$http.get('catalogo/getAlltipopagos')
                .then(response => {
                    if (response.status === 200) {
                        if (response.data) {
                            this.tipopagos = response.data
                        }
                    }
                })
                .catch(() => {
                });
        },
        async obtieneDatosFiscales() {
            this.$http.get(`DatosFiscales/${this.editedItem.contrato}`)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data) {
                            if (response.data) {
                                this.datosFiscales = { ...response.data };
                            }
                        } else {
                            this.datosFiscales = { RFC: "XAXX010101000", Correo: null };
                        }
                    }
                })
                .catch(() => {
                });
        }
    }
};
</script>